import React, { useState } from 'react';
import { InputV2Props, styled } from '@withjoy/joykit';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { EventInputV2 } from '@shared/createEvent/formElements/EventInputV2';
import { EyeIcon, OVERRIDE_HOVER_STYLES, endElementStyles, inputStyles, rootStyles } from '@shared/createEvent/formElements/formElements.styles';

const StyledEventPasswordInputV2 = styled(EventInputV2)`
  ${OVERRIDE_HOVER_STYLES};
`;

const EventPasswordInputV2 = React.forwardRef<HTMLInputElement, InputV2Props>((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePassword = useEventCallback(() => {
    setShowPassword(prevShowPassword => !prevShowPassword);
  }, []);

  return (
    <StyledEventPasswordInputV2
      ref={ref}
      {...props}
      type={showPassword ? 'text' : 'password'}
      endElement={<EyeIcon className={showPassword ? 'active' : ''} color="mono5" size={24} onClick={handleTogglePassword} />}
    />
  );
});

EventPasswordInputV2.defaultProps = {
  overrides: {
    Root: {
      props: rootStyles
    },
    Input: {
      props: inputStyles
    },
    EndElement: {
      props: endElementStyles
    }
  }
};

export { EventPasswordInputV2 };
